export default function Footer() {
  return (
    <div className="row" style={{marginTop:-25, marginLeft:25, color:"grey"}}>
        <p><a className="link" href="https://github.com/olivertemple/nea">GitHub</a> | This website was created by Oliver Temple for a Computer Science A Level NEA</p>
    </div>
  )
  }